module.exports = __webpack_public_path__ + "static/img/background.c92ea174.svg";